/**
 * Copyright (C) 2022, Merkur India.
 *
 * The program(s) herein may be used and/or copied only with
 * the written permission of Merkur India. or in accordance with
 * the terms and conditions stipulated in the agreement/contract
 * under which the program(s) have been supplied.
 *
 * $Id: BSPlayCommandClientPadding.ts ,v 1.0 Exp $
 * Date Author Changes
 * Feb 22, 2022 Shruti Agrawal Created
 *
 */

namespace GameFlow.Commands {
    import BaseGameState = States.BaseGameState;
    import ReelContainer = Reels.ReelContainer;
    import GameActionResponse = DTO.GameActionResponse;
    export class BSPlayCommandClientPadding extends PlayCommandClientPadding {
        protected injectResponse(response: GameActionResponse, reelContainer: ReelContainer, gameState: BaseGameState) {
            super.injectResponse(response, reelContainer, gameState);
            (reelContainer as Reels.BSReelContainer).injectResponse(response);
        }
    }
}
